import type {
  Article,
  ArticleResponse,
  ArticleStatusCounts,
  ArticleStatusCountsResponse,
  SolomonInsights,
} from './types';

export function mapSolomonInsights(raw: ArticleResponse['solomon_insights']): SolomonInsights | null {
  if (!raw) return null;
  return {
    summary: raw.summary,
    relatedVerses: raw.related_verses,
    reflectionPrompt: raw.reflection_prompt,
    generatedAt: raw.generated_at,
  };
}

export function mapArticle(response: ArticleResponse): Article {
  return {
    id: response.id,
    artistId: response.artist_id,
    title: response.title,
    slug: response.slug,
    coverImageUrl: response.cover_image_url,
    content: response.content,
    excerpt: response.excerpt,
    status: response.status,
    category: response.category_id,
    tags: response.tags,
    seoTitle: response.seo_title,
    seoDescription: response.seo_description,
    solomonInsights: mapSolomonInsights(response.solomon_insights),
    readingTime: response.reading_time,
    authorName: response.author_name,
    authorImageUrl: response.author_image_url,
    contentId: response.content_id,
    publishedAt: response.published_at,
    createdAt: response.created_at,
    updatedAt: response.updated_at,
    source: response.source ?? 'editorial',
    sourceEpisode: response.source_episode
      ? {
          id: response.source_episode.id,
          title: response.source_episode.title,
          imageUrl: response.source_episode.image_url,
          mediaType: response.source_episode.media_type ?? null,
          durationSeconds: response.source_episode.duration_seconds ?? null,
          contentSeries: response.source_episode.content_series
            ? {
                id: response.source_episode.content_series.id,
                name: response.source_episode.content_series.name,
              }
            : null,
        }
      : null,
    review: response.review
      ? {
          checksPassed: response.review.checks_passed,
          checkFailures: response.review.check_failures,
          generatedAt: response.review.generated_at,
          model: response.review.model,
        }
      : null,
  };
}

export function mapArticleStatusCounts(response?: ArticleStatusCountsResponse | null): ArticleStatusCounts | null {
  if (!response) return null;
  return {
    total: response.total,
    draft: response.draft,
    published: response.published,
    unpublished: response.unpublished,
    needsAttention: response.needs_attention,
  };
}

export function mapArticles(responses: ArticleResponse[]): Article[] {
  return responses.map(mapArticle);
}
